// extracted by mini-css-extract-plugin
export default {"container":"ShopAdminDownload_container__F2nH7","buttonsContainer":"ShopAdminDownload_buttonsContainer__h-nTt"};